import React, { useState } from 'react';
import {
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import {
  AccountCircleOutlined as AccountCircleIcon,
  LogoutOutlined as LogoutIcon,
  PersonOutlined as PersonIcon,
  ReceiptLongOutlined as BillingIcon,
  SettingsOutlined as SettingsIcon,
  PaletteOutlined as PreferencesIcon,
} from '@mui/icons-material';
import AccountProfileDialog from './AccountProfileDialog';
import AccountPreferencesDialog from './AccountPreferencesDialog';
import AccountBillingDialog from './AccountBillingDialog';

/**
 * Landlord AppBar account menu (Gate G2 / ZRF-ACC-01).
 */
export default function AccountMenu({ user, onLogout, onNavigateTab }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileOpen, setProfileOpen] = useState(false);
  const [preferencesOpen, setPreferencesOpen] = useState(false);
  const [billingOpen, setBillingOpen] = useState(false);

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const go = (tab) => {
    handleClose();
    onNavigateTab?.(tab);
  };

  return (
    <>
      <Tooltip title="Account">
        <IconButton
          color="inherit"
          aria-label="Account menu"
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleOpen}
        >
          <AccountCircleIcon />
        </IconButton>
      </Tooltip>

      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { minWidth: 220 } }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            setProfileOpen(true);
          }}
        >
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Profile" secondary={user?.email || undefined} />
        </MenuItem>

        <MenuItem onClick={() => go('settings')}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Settings" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            setPreferencesOpen(true);
          }}
        >
          <ListItemIcon>
            <PreferencesIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Preferences" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            setBillingOpen(true);
          }}
        >
          <ListItemIcon>
            <BillingIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Billing" />
        </MenuItem>

        <Divider />

        <MenuItem
          onClick={() => {
            handleClose();
            onLogout?.();
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Sign out" />
        </MenuItem>
      </Menu>

      <AccountProfileDialog
        open={profileOpen}
        onClose={() => setProfileOpen(false)}
        user={user}
      />
      <AccountPreferencesDialog
        open={preferencesOpen}
        onClose={() => setPreferencesOpen(false)}
        onOpenNotifications={() => onNavigateTab?.('notifications')}
      />
      <AccountBillingDialog open={billingOpen} onClose={() => setBillingOpen(false)} />
    </>
  );
}
